import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Image } from '../common/style/components/image'
import { NewTabLink } from '../common/style/components/links'
import { illustration1x, illustration2x, illustration3x } from './assets'

export const CompatibilityPage: React.FC = () => {
  const [t] = useTranslation('compatibility')
  return (
    <Wrapper>
      <div>
        <Image
          src={illustration1x}
          srcSet={`${illustration2x} 2x, ${illustration3x} 3x`}
        />
      </div>
      <Title> {t('title')} </Title>
      <Text>
        <p>{t('text')}</p>
        <p>
          <NewTabLink
            to="https://www.google.fr/chrome/browser/desktop/index.html"
            eventLabel="install chrome"
          >
            {t('chrome_link')}
          </NewTabLink>
        </p>
      </Text>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f9fbff;
`

const Title = styled.h1`
  text-align: center;
`
const Text = styled.div`
  text-align: center;
`
